(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hubspot-popup"] && !Shopify.designMode) return;
  try {
    const HS_POPUP_SHOWN_COOKIE = 'hs_popup_shown';
  const HS_POPUP_SUBSCRIBED = 'hs_popup_subscribed';
  const HS_POPUP_FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // localStorage throws in some private modes and when site data is blocked.
  const popupStorage = {
    get(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {}
    },
  };

  // A cookie without an expiry lasts for the browser session and is shared by all tabs, unlike sessionStorage.
  const sessionCookie = {
    has(name) {
      return document.cookie.split('; ').some((entry) => entry.startsWith(`${name}=`));
    },
    set(name) {
      document.cookie = `${name}=1; path=/; SameSite=Lax`;
    },
  };

  const isPopupSuppressed = () =>
    Boolean(popupStorage.get(HS_POPUP_SUBSCRIBED)) || sessionCookie.has(HS_POPUP_SHOWN_COOKIE);

  const loadFormScript = (src, force) => {
    if (!src) return;
    if (!force && document.querySelector(`script[src="${src}"]`)) return;
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.body.appendChild(script);
  };

  const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode);

  const setupPopup = () => {
    const popup = document.querySelector('[data-marketing-popup]');
    if (!popup) return null;

    const modal = popup.querySelector('[role="dialog"]');
    const designMode = isDesignMode();
    const delaySeconds = Number.parseFloat(popup.dataset.marketingPopupDelay || '0');
    let lastFocused = null;

    const show = () => {
      if (!popup.hasAttribute('hidden')) return;
      lastFocused = document.activeElement;
      popup.removeAttribute('hidden');
      document.documentElement.classList.add('hs-popup-open');
      modal.focus();
      // Count the impression so the popup does not follow the visitor to every page.
      if (!designMode) sessionCookie.set(HS_POPUP_SHOWN_COOKIE);
    };

    const hide = () => {
      if (popup.hasAttribute('hidden')) return;
      popup.setAttribute('hidden', '');
      document.documentElement.classList.remove('hs-popup-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    popup.querySelectorAll('[data-marketing-popup-close]').forEach((button) => button.addEventListener('click', hide));
    popup.addEventListener('click', (event) => {
      if (event.target === popup) hide();
    });

    // Recheck on show because another tab can suppress the popup during the delay.
    const showUnlessSuppressed = () => {
      if (designMode || !isPopupSuppressed()) show();
    };

    if (designMode || !isPopupSuppressed()) {
      loadFormScript(popup.dataset.scriptSrc);
      if (delaySeconds > 0) {
        window.setTimeout(showUnlessSuppressed, delaySeconds * 1000);
      } else {
        showUnlessSuppressed();
      }
    }

    return { popup, modal, designMode, formId: popup.dataset.formId, show, hide };
  };

  let instance = setupPopup();

  window.addEventListener('hs-form-event:on-submission:success', (event) => {
    if (!instance || instance.designMode) return;
    const formId = event.detail && event.detail.formId;
    if (formId && formId !== instance.formId) return;
    popupStorage.set(HS_POPUP_SUBSCRIBED, 'true');
  });

  document.addEventListener('keydown', (event) => {
    if (!instance || instance.popup.hasAttribute('hidden') || event.defaultPrevented) return;

    if (event.key === 'Escape') {
      instance.hide();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(instance.modal.querySelectorAll(HS_POPUP_FOCUSABLE)).filter(
      (element) => element.getClientRects().length > 0
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || active === instance.modal || !instance.modal.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !instance.modal.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  });

  if (isDesignMode()) {
    const containsPopup = (target) => target && instance && target.contains(instance.popup);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelector('[data-marketing-popup]')) {
        document.documentElement.classList.remove('hs-popup-open');
        instance = setupPopup();
        // Rerun the HubSpot script only if it did not render the replaced container by itself.
        window.setTimeout(() => {
          const container = instance && instance.popup.querySelector('.hs-form-html');
          if (container && !container.children.length) loadFormScript(instance.popup.dataset.scriptSrc, true);
        }, 2000);
      }
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (containsPopup(event.target)) instance.show();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (containsPopup(event.target)) instance.hide();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["publitas-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    const card = document.querySelector('.pb-card');
    if (!card) return;
    const variantSelect = card.querySelector('[data-variant-select]');
    const priceEl = card.querySelector('[data-price-current]');
    const compareEl = card.querySelector('[data-price-compare]');
    const skuEl = card.querySelector('[data-sku]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        const opt = variantSelect.selectedOptions[0];
        if (!opt) return;
        if (priceEl) priceEl.textContent = opt.dataset.price;
        if (compareEl) compareEl.textContent = opt.dataset.compare;
        if (skuEl) skuEl.textContent = opt.dataset.sku;
      });
    }
    const heroImg = card.querySelector('.pb-card__hero');
    card.querySelectorAll('.pb-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (heroImg) heroImg.src = btn.dataset.mediaSrc;
        card.querySelectorAll('.pb-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
    const form = card.querySelector('[data-publitas-form]');
    if (!form) return;
    const cta = form.querySelector('[data-add-to-cart]');
    const ctaLabel = form.querySelector('[data-cta-label]');
    const msg = form.querySelector('[data-cta-msg]');
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      cta.disabled = true;
      ctaLabel.textContent = 'Adding…';
      msg.hidden = true;
      try {
        const res = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) {
          const err = await res.json().catch(function () { return {}; });
          throw new Error(err.description || 'Add to cart failed');
        }
        const item = await res.json();
        if (window.parent !== window) {
          parent.postMessage(JSON.stringify(['publitasPdpItemAdded', String(item.id || ''), String(item.quantity || 1)]), '*');
          parent.postMessage(JSON.stringify(['publitasTrackAddToCart', { productId: item.product_id, variantId: item.variant_id, quantity: item.quantity, title: item.product_title, price: item.final_price / 100 }]), '*');
        }
        ctaLabel.textContent = 'Added ✓';
        setTimeout(function () { cta.disabled = false; ctaLabel.textContent = 'Add to cart'; }, 1200);
      } catch (err) {
        msg.textContent = err.message || 'Sorry, that variant is unavailable.';
        msg.hidden = false;
        cta.disabled = false;
        ctaLabel.textContent = 'Add to cart';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
